import React, { Component } from "react";
import ReactGA from "react-ga";
import FormTitle from "../FormTitle/FormTitle";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
import classes from "./FormSizeOfPlan.module.scss";
import { withRouter } from "react-router-dom";

import PlanContent from "./PlanContent/PlanContent";

class FormSizeOfPlan extends Component {
  componentDidMount() {
    this.setState({ viewPlan: this.props[ROUTES.PAGE_3_KEY] });
    this.props.updateMultipleSelectedChoices({
      [ROUTES.PAGE_3_KEY]: "",
      // [ROUTES.PAGE_4_KEY]: {},
      [ROUTES.PAGE_5_KEY]: "",
      selectYourSeatsUuid: "",
      buid: "",
      seatInfoSelected: "",
      numOfSeat: "",
      // benefitSubmit: false
    });
    this.setState((state) => ({ viewPlan: "" }));

    if (this.props.formStart === "") {
      this.props.history.push("/");
    } else {
      if (window.adobeAnalytics) {
        window.adobeAnalytics.t({
          pageName:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Size of plan",
        });
      }
    }
    if (this.props.formStyle === "ballpark") {
      this.props.history.push("style-of-plan");
    }
    this.createplans();
    ReactGA.pageview("/size-of-plan");
  }

  state = {
    viewPlan: "",
    planSizeValues: null,
  };

  async createplans() {
    if (this.props.cms) {
      const _planSizeValues = {};
      const cms = this.props.cms;
      cms.forEach((style, index) => {
        let stylename = cms[index].name.toLowerCase();

        _planSizeValues[stylename] = [];

        style.plans.forEach((plan) => {
          _planSizeValues[stylename].push({
            numOfGames: plan.gameNum,
            priceRange: plan.priceStart,
            avgSavings: plan.sizeAvgSavings,
            concession: plan.sizeConcession,
            numOfSeats: plan.sizeNumOfSeats,
            postSeason: plan.sizePostSeason,
            guaranteedBobbleheads: plan.sizeGuaranteedBobbleheads,
            openingDayAccess: plan.sizeOpeningDayAccess,
            exclusiveEventsWithPlayers: plan.sizeExclusiveEventsWithPlayers,
            planChoice: plan.sizePlanChoice,
          });
        });
      });
      // console.log('cms', cms);
      this.setState({ planSizeValues: _planSizeValues });
    }
  }
  onClickSizeOfPlanChoice = (plan) => {
    this.setState((state) => ({ viewPlan: plan, disableSubmit: false }));

    this.props.updateSelectedChoices(ROUTES.PAGE_3_KEY, plan);
  };

  render() {
    if (!this.state.planSizeValues) {
      return <p>Loading ...</p>;
    }
    let styleOfPlanSelected = [];
    // filter small plans
    switch (this.props[ROUTES.PAGE_2_KEY]) {
      case "classic":
        if (this.props.planType === "premier") {
          styleOfPlanSelected = this.state.planSizeValues[
            this.props[ROUTES.PAGE_2_KEY]
          ].filter(
            (plan) =>
              plan.planChoice === "eightyClassic" ||
              plan.planChoice === "fortyClassic" ||
              plan.planChoice === "twentyClassic"
          );
        } else if (this.props.planType === "small") {
          styleOfPlanSelected = this.state.planSizeValues[
            this.props[ROUTES.PAGE_2_KEY]
          ].filter(
            (plan) =>
              plan.planChoice === "tenClassic" ||
              plan.planChoice === "fiveClassic"
          );
        }
        break;

      case "flexible":
        styleOfPlanSelected =
          this.state.planSizeValues[this.props[ROUTES.PAGE_2_KEY]];
        break;

      default:
        break;
    }

    return (
      <div>
        <div>
          <FormTitle
            title="Choose the size of your plan"
            subTitle={
              this.props.planType === "premier"
                ? `Price of the ticket plans set forth below includes a $20 processing fee per seat`
                : this.props.planType === "small"
                ? `Price of the ticket plans set forth below includes a $12.50 processing fee per seat`
                : this.props.planType === "pickem"
                ? `Price of the ticket plans set forth below includes a $25 - 40  processing fee per plan`
                : ``
            }
          />

          {this.props[ROUTES.PAGE_2_KEY] !== "" ? (
            <>
              <PlanContent
                styleOfPlanSelectedName={this.props[ROUTES.PAGE_2_KEY]}
                styleOfPlanSelected={styleOfPlanSelected}
                sizeOfPlanSelected={this.state.viewPlan}
                onClickSizeOfPlanChoice={this.onClickSizeOfPlanChoice}
                planType={this.props.planType}
              />
              <FormController
                // backTo={ROUTES.PAGE_1_LINK}
                //TODO: uncomment when suppressing style of plan
                backTo={ROUTES.PAGE_2_LINK}
                nextTo={ROUTES.PAGE_5_LINK}
                startOver={ROUTES.PAGE_1_LINK}
                showBack
                showStartOver
                showSkip={false}
                showSubmit
                submitText="Continue"
                disableSubmit={this.state.viewPlan === ""}
              />
            </>
          ) : (
            <div className={classes.errorMsg}>No Selected Plan Selected</div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(FormSizeOfPlan);
